export default function handleSubmit(
  { group: { title, groupSpaceIds, spacePlanId } },
  { props: { id, submit } }
) {
  const group = { id, title, spaceIds: groupSpaceIds, spacePlanId }
  return submit(group)
}
